import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {MediaSelectorImageVerticalComponent} from './media-selector-image-vertical/media-selector-image-vertical.component';
import {MediaUploadCameraComponent} from './media-upload-camera/media-upload-camera.component';
import { MediaSelectorsComponent } from './media-selectors/media-selectors.component';
import {ImageAnnotationModule} from '../image-annotation/image-annotation.module';
import {SharedModule} from '../shared/shared.module';
import { MediaSelectorGeneralComponent } from './media-selector-general/media-selector-general.component';
import {MediaListComponent} from './media-list/media-list.component';
import {ObjectEditModule} from '../object-edit/object-edit.module';
import {MatLegacyCheckboxModule as MatCheckboxModule} from '@angular/material/legacy-checkbox';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MediaSelectorSelectedFilesComponent} from './media-selector-selected-files/media-selector-selected-files.component';
import {MatLegacyTabsModule as MatTabsModule} from '@angular/material/legacy-tabs';
import {MatIconModule} from '@angular/material/icon';
import {MatLegacyProgressSpinnerModule as MatProgressSpinnerModule} from '@angular/material/legacy-progress-spinner';
import {MatLegacyMenuModule as MatMenuModule} from '@angular/material/legacy-menu';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatLegacyTooltipModule as MatTooltipModule} from '@angular/material/legacy-tooltip';

@NgModule({
  declarations: [
    MediaUploadCameraComponent,
    MediaSelectorImageVerticalComponent,
    MediaSelectorsComponent,
    MediaSelectorGeneralComponent,
    MediaSelectorSelectedFilesComponent,
    MediaListComponent
  ],
    imports: [
        CommonModule,
        FormsModule,
        DragDropModule,
        SharedModule,
        ImageAnnotationModule,
        ObjectEditModule,
        MatCheckboxModule,
        MatButtonModule,
        MatTabsModule,
        MatIconModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatExpansionModule,
        MatTooltipModule
    ],
  exports: [
    MediaSelectorGeneralComponent,
    MediaSelectorSelectedFilesComponent,
    MediaSelectorsComponent,
    MediaSelectorImageVerticalComponent,
    MediaListComponent
  ]
})
export class MediaSelectorModule {
}
